// extracted by mini-css-extract-plugin
export default {"container":"p6J-KbEivuLIhJxvZinV7Q==","illustration":"_3-TXRgY6jsD0hL9SRF9myg==","title":"wkE-7EYDWcamZrLcUwhRlQ==","subtitle":"_8xbQURlzrPEfsh8hADxdNg=="};